import { usePrepareCheckoutQuery } from '@/redux/api/client/checkout';
import { useState } from 'react';

const useCheckout = () => {
  const [billingAddressSk, setBillingAddressSk] = useState<number | undefined>(undefined);
  const [shippingAddressSk, setShippingAddressSk] = useState<number | undefined>(undefined);

  const { data, isLoading, refetch, isFetching } = usePrepareCheckoutQuery({
    billingAddressSk: billingAddressSk,
    shippingAddressSk: shippingAddressSk
  });

  return {
    isShippingRequired: data?.cart?.orderLines?.some(x => x.isStockItem ?? false),
    selectedBillingAddress: data?.selectedBillingAddress,
    selectedShippingAddress: data?.selectedShippingAddress,
    isLoading: isLoading || isFetching,
    refetch,
    setBillingAddressSk,
    setShippingAddressSk
  };
};

export default useCheckout;
